<div class="theme-selector">
    <app-select
        (valueChange)="emit_theme_change($event)"
        [label]="labels.theme"
        [list]="themes$$()"
        [value]="selectedGuid$$()"
    />

    <app-button-toggle
        (valueChange)="emit_colorMode_change($event)"
        [label]="labels.colorMode"
        [list]="colorModes"
        [value]="_theme.ColorModePreference$$()"
    />
</div>
